import React, { useState } from 'react';
import { BilingualText } from '../components/BilingualText';
import { ArrowLeft, Mail, Settings2, History, Bell, Search, Filter, RefreshCw, CheckCircle2, XCircle, Clock, ChevronRight, Eye, FileText, AlertTriangle } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
type NotificationTab = 'center' | 'templates' | 'settings';
export function Notifications() {
  const [activeTab, setActiveTab] = useState<NotificationTab>('center');
  const navigate = useNavigate();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-746">
      <header className="bg-white px-4 py-6 border-b border-slate-200 flex items-center justify-between sticky top-0 z-10 lg:px-8" data-id="element-747">
        <div className="flex items-center gap-4" data-id="element-748">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-749">
            <ArrowLeft size={24} data-id="element-750" />
          </button>
          <BilingualText en="Notifications" ar="التنبيهات" className="text-xl font-bold" data-id="element-751" />
        </div>
        <div className="flex gap-2" data-id="element-752">
          <button className="btn-secondary py-2 px-4 text-sm hidden sm:flex" data-id="element-753">
            <RefreshCw size={18} data-id="element-754" />
            <span data-id="element-755">Refresh Queue</span>
          </button>
        </div>
      </header>

      <main className="p-4 md:p-8 max-w-7xl mx-auto space-y-8" data-id="element-756">
        {/* Tab Navigation */}
        <div className="flex border-b border-slate-200 gap-8" data-id="element-757">
          <TabButton active={activeTab === 'center'} onClick={() => setActiveTab('center')} en="Notification Center" ar="مركز التنبيهات" data-id="element-758" />
          <TabButton active={activeTab === 'templates'} onClick={() => setActiveTab('templates')} en="Email Templates" ar="قوالب البريد" data-id="element-759" />
          <TabButton active={activeTab === 'settings'} onClick={() => setActiveTab('settings')} en="Settings" ar="الإعدادات" data-id="element-760" />
        </div>

        {activeTab === 'center' && <div className="space-y-6 animate-in fade-in duration-500" data-id="element-761">
            {/* KPI Cards */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-762">
              <NotifyKpi label="Pending" value="12" color="text-yellow-600" bgColor="bg-yellow-50" data-id="element-763" />
              <NotifyKpi label="Sent Today" value="145" color="text-green-600" bgColor="bg-green-50" data-id="element-764" />
              <NotifyKpi label="Failed" value="3" color="text-red-600" bgColor="bg-red-50" data-id="element-765" />
              <NotifyKpi label="Delivered" value="98%" color="text-blue-600" bgColor="bg-blue-50" data-id="element-766" />
            </div>

            <div className="flex flex-col md:flex-row gap-4" data-id="element-767">
              <div className="flex-1 relative" data-id="element-768">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} data-id="element-769" />
                <input type="text" placeholder="Search by Shipment, Supplier or Email..." className="w-full pl-10 pr-4 py-3 bg-white border border-slate-200 rounded-xl shadow-sm" data-id="element-770" />
              </div>
              <button className="btn-secondary py-3 px-4" data-id="element-771">
                <Filter size={18} data-id="element-772" />
                <span data-id="element-773">Filters</span>
              </button>
            </div>

            <div className="card overflow-hidden" data-id="element-774">
              <table className="w-full text-left" data-id="element-775">
                <thead className="bg-slate-50 text-slate-400 text-xs uppercase tracking-wider" data-id="element-776">
                  <tr data-id="element-777">
                    <th className="px-6 py-4 font-bold" data-id="element-778">Date & Time</th>
                    <th className="px-6 py-4 font-bold" data-id="element-779">Type</th>
                    <th className="px-6 py-4 font-bold" data-id="element-780">Recipient</th>
                    <th className="px-6 py-4 font-bold" data-id="element-781">Status</th>
                    <th className="px-6 py-4 font-bold text-right" data-id="element-782">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100" data-id="element-783">
                  <NotificationRow date="July 11, 10:30 AM" type="Appointment Approved" recipient="Global Logistics" email="ops@global.com" status="Delivered" data-id="element-784" />
                  <NotificationRow date="July 11, 10:15 AM" type="Truck Checked-in" recipient="FastTrack Trading" email="info@fasttrack.com" status="Sent" data-id="element-785" />
                  <NotificationRow date="July 11, 09:45 AM" type="Capacity Alert" recipient="WH Manager" email="manager@das.com" status="Failed" data-id="element-786" />
                  <NotificationRow date="July 11, 09:30 AM" type="Appointment Requested" recipient="Warehouse Staff" email="staff@das.com" status="Pending" data-id="element-787" />
                </tbody>
              </table>
            </div>
          </div>}

        {activeTab === 'templates' && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 animate-in slide-in-from-bottom-4 duration-500" data-id="element-788">
            <TemplateCard name="Appointment Approved" subject="Your appointment is confirmed" status="Active" data-id="element-789" />
            <TemplateCard name="Appointment Rejected" subject="Appointment request update" status="Active" data-id="element-790" />
            <TemplateCard name="Truck Checked-in" subject="Truck arrived at warehouse" status="Active" data-id="element-791" />
            <TemplateCard name="Receiving Started" subject="Receiving in progress" status="Active" data-id="element-792" />
            <TemplateCard name="Shipment Completed" subject="Shipment received successfully" status="Active" data-id="element-793" />
            <TemplateCard name="Capacity Alert" subject="Warehouse Capacity Warning" status="Active" data-id="element-794" />
          </div>}

        {activeTab === 'settings' && <div className="max-w-3xl mx-auto space-y-6 animate-in fade-in duration-500" data-id="element-795">
            <section className="card p-6 space-y-6" data-id="element-796">
              <BilingualText en="General Notification Settings" ar="إعدادات التنبيهات العامة" className="text-xl" data-id="element-797" />

              <div className="space-y-4" data-id="element-798">
                <ToggleSetting label="Enable Email Notifications" description="Send automatic emails for all system events" defaultChecked data-id="element-799" />
                <ToggleSetting label="Daily Schedule Reminder" description="Send a summary of tomorrow's appointments to staff" defaultChecked data-id="element-800" />
                <ToggleSetting label="Retry Failed Emails" description="Automatically attempt to resend failed emails up to 3 times" defaultChecked data-id="element-801" />
              </div>

              <div className="pt-6 border-t border-slate-100 space-y-4" data-id="element-802">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-803">
                  <div className="space-y-2" data-id="element-804">
                    <label className="text-xs font-bold text-slate-400 uppercase" data-id="element-805">
                      Default Sender Name
                    </label>
                    <input type="text" defaultValue="DAS System" className="w-full p-3 bg-slate-50 border border-slate-200 rounded-lg" data-id="element-806" />
                  </div>
                  <div className="space-y-2" data-id="element-807">
                    <label className="text-xs font-bold text-slate-400 uppercase" data-id="element-808">
                      Default Sender Email
                    </label>
                    <input type="email" defaultValue="system@das-warehouse.com" className="w-full p-3 bg-slate-50 border border-slate-200 rounded-lg" data-id="element-809" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-810">
                  <label className="text-xs font-bold text-slate-400 uppercase" data-id="element-811">
                    Capacity Alert Threshold
                  </label>
                  <select className="w-full p-3 bg-slate-50 border border-slate-200 rounded-lg" data-id="element-812">
                    <option data-id="element-813">70% Utilization</option>
                    <option selected data-id="element-814">90% Utilization</option>
                    <option data-id="element-815">100% (Full)</option>
                  </select>
                </div>
              </div>

              <div className="pt-4" data-id="element-816">
                <button className="btn-primary w-full py-4" data-id="element-817">
                  Save Notification Settings
                </button>
              </div>
            </section>
          </div>}
      </main>
    </div>;
}
function TabButton({
  active,
  onClick,
  en,
  ar
}: any) {
  return <button onClick={onClick} className={`pb-4 px-2 transition-all relative ${active ? 'text-[#2E3192] font-bold' : 'text-slate-400 hover:text-slate-600'}`} data-id="element-818">
      <BilingualText en={en} ar={ar} className="text-sm" data-id="element-819" />
      {active && <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#2E3192] rounded-t-full" data-id="element-820" />}
    </button>;
}
function NotifyKpi({
  label,
  value,
  color,
  bgColor
}: any) {
  return <div className={`card p-4 border-none ${bgColor}`} data-id="element-821">
      <div className={`text-2xl font-black ${color}`} data-id="element-822">{value}</div>
      <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider" data-id="element-823">
        {label}
      </div>
    </div>;
}
function NotificationRow({
  date,
  type,
  recipient,
  email,
  status
}: any) {
  const statusColors: any = {
    Delivered: 'bg-green-100 text-green-700',
    Sent: 'bg-blue-100 text-blue-700',
    Failed: 'bg-red-100 text-red-700',
    Pending: 'bg-yellow-100 text-yellow-700'
  };
  return <tr className="hover:bg-slate-50 transition-colors group" data-id="element-824">
      <td className="px-6 py-4 text-sm text-slate-500 font-medium" data-id="element-825">{date}</td>
      <td className="px-6 py-4" data-id="element-826">
        <div className="text-sm font-bold text-slate-700" data-id="element-827">{type}</div>
        <div className="text-[10px] text-slate-400 font-bold uppercase" data-id="element-828">
          Email
        </div>
      </td>
      <td className="px-6 py-4" data-id="element-829">
        <div className="text-sm font-bold text-slate-700" data-id="element-830">{recipient}</div>
        <div className="text-xs text-slate-400" data-id="element-831">{email}</div>
      </td>
      <td className="px-6 py-4" data-id="element-832">
        <span className={`text-[10px] font-bold px-2 py-0.5 rounded uppercase ${statusColors[status]}`} data-id="element-833">
          {status}
        </span>
      </td>
      <td className="px-6 py-4 text-right" data-id="element-834">
        <button className="p-2 text-slate-400 hover:text-[#2E3192] transition-colors" data-id="element-835">
          <Eye size={18} data-id="element-836" />
        </button>
      </td>
    </tr>;
}
function TemplateCard({
  name,
  subject,
  status
}: any) {
  return <div className="card p-5 space-y-4 hover:border-[#2E3192] transition-all group" data-id="element-837">
      <div className="flex justify-between items-start" data-id="element-838">
        <div className="p-2 bg-blue-50 text-[#2E3192] rounded-lg" data-id="element-839">
          <FileText size={20} data-id="element-840" />
        </div>
        <span className="text-[10px] font-bold px-2 py-0.5 bg-green-100 text-green-700 rounded uppercase" data-id="element-841">
          {status}
        </span>
      </div>
      <div data-id="element-842">
        <div className="font-bold text-slate-800" data-id="element-843">{name}</div>
        <div className="text-xs text-slate-400 mt-1 line-clamp-1" data-id="element-844">
          Subject: {subject}
        </div>
      </div>
      <div className="flex gap-2 pt-2" data-id="element-845">
        <button className="flex-1 text-xs font-bold py-2 bg-slate-50 text-slate-600 rounded-lg hover:bg-slate-100 transition-colors" data-id="element-846">
          Edit
        </button>
        <button className="flex-1 text-xs font-bold py-2 bg-blue-50 text-[#2E3192] rounded-lg hover:bg-blue-100 transition-colors" data-id="element-847">
          Preview
        </button>
      </div>
    </div>;
}
function ToggleSetting({
  label,
  description,
  defaultChecked = false
}: any) {
  return <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl" data-id="element-848">
      <div data-id="element-849">
        <div className="text-sm font-bold text-slate-700" data-id="element-850">{label}</div>
        <div className="text-xs text-slate-400" data-id="element-851">{description}</div>
      </div>
      <div className={`w-12 h-6 rounded-full p-1 transition-colors cursor-pointer ${defaultChecked ? 'bg-[#2E3192]' : 'bg-slate-300'}`} data-id="element-852">
        <div className={`w-4 h-4 bg-white rounded-full transition-transform ${defaultChecked ? 'translate-x-6' : 'translate-x-0'}`} data-id="element-853" />
      </div>
    </div>;
}